define('modules/form_editor/views/preview_element_factory',['require','exports','module','./preview_text','./preview_textarea','./preview_radio_group','./preview_check_group','./preview_dropdown','./preview_hidden','./preview_custom_terms','./preview_custom_privacy','./preview_custom_telephone','./preview_custom_email','./preview_custom_date','./preview_custom_date_amp','./preview_custom_gender','./preview_custom_password','./preview_custom_iban','./preview_custom_day','./preview_custom_month','./preview_custom_year','./preview_custom_fblogin','./preview_custom_linlogin','./preview_custom_google_recaptcha','./preview_custom_separator'],function(require, exports, module){
  "use strict";
  var ModelViewMappings = {
    "input:text": require("./preview_text"),
    "input:textarea": require("./preview_textarea"),
    "input:radiogroup": require("./preview_radio_group"),
    "input:checkgroup": require("./preview_check_group"),
    "input:dropdown": require("./preview_dropdown"),
    "input:hidden": require("./preview_hidden"),
    "custom:terms": require("./preview_custom_terms"),
    "custom:privacy": require("./preview_custom_privacy"),
    "custom:telephone": require("./preview_custom_telephone"),
    "custom:email": require("./preview_custom_email"),
    "custom:date": require("./preview_custom_date"),
    "custom:date_amp": require("./preview_custom_date_amp"),
    "custom:gender": require("./preview_custom_gender"),
    "custom:password": require("./preview_custom_password"),
    "custom:iban": require("./preview_custom_iban"),
    "custom:day": require("./preview_custom_day"),
    "custom:month": require("./preview_custom_month"),
    "custom:year": require("./preview_custom_year"),
    "custom:login:facebook": require("./preview_custom_fblogin"),
    "custom:login:linkedin": require("./preview_custom_linlogin"),
    "custom:captcha:google_recaptcha": require("./preview_custom_google_recaptcha"),
    "custom:separator": require("./preview_custom_separator")
  };

  module.exports = function(options) {
    var name = options.model.get("name");

    // backwards compatibility, delete after some time
    if (name === "custom:fblogin") options.model.set("name", "custom:login:facebook", {silent: true});
    return new ModelViewMappings[name](options);
  };
});

